export default __webpack_public_path__ + "static/bahrain-back-05228d89283b4b45b89863fc8cdf5867.webp";